import { TableColumns } from '@/components/table/types';
import { Dispatch, SetStateAction } from 'react';

export const selectColumns = (key: string, newColumns: TableColumns[], setNewColumns: Dispatch<SetStateAction<TableColumns[]>>) => {
  const newColumnsList = newColumns.map((element: TableColumns) => {
    if (key === element.keySort) {
      element.isHidden = !element.isHidden;
    }
    return element;
  });
  setNewColumns(newColumnsList);
};

export const handleRemoveColumn = (key: string, newColumns: TableColumns[], setNewColumns: Dispatch<SetStateAction<TableColumns[]>>) => {
  const newColumnsList = newColumns.map((element: TableColumns) => {
    if (key === element.keySort) {
      element.isHidden = true;
    }
    return element;
  });

  setNewColumns(newColumnsList);
};

export const handleSelectAll = ({
  isHidden,
  newColumns,
  setNewColumns
}: {
  isHidden: boolean;
  newColumns: TableColumns[];
  setNewColumns: Dispatch<SetStateAction<TableColumns[]>>;
}) => {
  const newColumnsList = newColumns.map((element: TableColumns) => {
    if (element.isFixed) return element;
    element.isHidden = isHidden;
    return element;
  });

  setNewColumns(newColumnsList);
};
